//BOOTSTRAP
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Row, Col, Card, Form } from 'react-bootstrap';
import "./Login.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import logo from "../../Images/quatroLogo.jpg";
import fondo from "../../Images/background_login.jpg";
import {  useState  } from 'react';
import Swal from "sweetalert2";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";


import UserCreatePassword from '../../Components/UserCreatePassword/UserCreatePassword';

function Login() {


  //ENV VARIABLE
  const apiUrl = process.env.REACT_APP_API_URL;
  const backendAPI_Key = process.env.REACT_APP_API_KEY;

  const [username, setUsername] = useState("");
  const [currentUserID, setCurrentUserID] = useState("");
  const [password, setPassword] = useState("");

  //CREATE PASSWORD MODAL
  const [showModal_CreatePassword, setShowModal_CreatePassword] = useState(false);
  
  const [loadingLogin, setLoadingLogin] = useState(false);
  
  const openCreatePasswordModal = (currentUserID) => {
    setCurrentUserID(currentUserID);
    setShowModal_CreatePassword(true);
  }

  const setRequestCloseModal_CreatePassword = () => {
    setShowModal_CreatePassword(false);
  }
  

  //
  const requestLogin = async () => {

      const endpoint = "checkLogin";

      //
      const requestBody = {
          "username": username,
          "password": password
      };


      //GRAPHICS EFFECT
      setLoadingLogin(true);

      //
      const response = await fetch(apiUrl + endpoint,
      {
          method: "POST",
          headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
          body: JSON.stringify(requestBody)
      });

      const responseContent = await response.json();
      console.log(responseContent);
      if(responseContent.password_blank === "true") { //NEW USER - BLANK PASSWORD
       
        //OPEN MODAL TO CREATE PASSWORD
        openCreatePasswordModal(responseContent.id);
       
      } else if(responseContent.id === 0) {

        //LOGIN FAILED
        Swal.fire({
            title: "Error en el login!",
            text: "Usuario y/o password incorrecto.",
            icon: "error",
            confirmButtonText: "OK"
        });
        
      } else if(responseContent.id > 0) {  //
        
        //Store Session
        sessionStorage.setItem("userSession", JSON.stringify(responseContent));

        //
        window.location.href = "/OrderListing";

      } 


      //GRAPHICS EFFECT
      setLoadingLogin(false);

  } //END FUNCTION


  return (
    <div style={{paddingTop:"90px", background:`URL(${fondo})`, backgroundSize:"cover", height: "800px" }}>
      <Row >
        <Col md={4}></Col>
        <Col md={4} xs={12} style={{textAlign:"center", paddingLeft:"20px", paddingRight:"20px"}}>
          <Card style={{ maxWidth: "450px" }}>
            <Card.Title style={{backgroundColor: "#172f80", height: "5px"}}></Card.Title>
            <Card.Body>

              <Row>
                <Col xs={3}  className='' style={{paddingTop:"10px"}}>
                  <img src={logo} alt="Logo" style={{ width: "90px"}}/>
                </Col>

                <Col xs={9}  className='title' style={{paddingTop:"20px", borderLeft: "1px solid #b8b8b8"}}>
                  Gestor de Ordenes de Servicio
                </Col>

              </Row>

              <hr />
              <br />

              <Col xs={12} 
                  style={{paddingLeft: "40px", paddingRight:"40px", lineHeight:"10px"}}
              >
              <Form.Label className='subTitle_1'>Ingrese sus credenciales de acceso</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Usuario" 
                onChange={(event)=> setUsername(event.target.value)} /><br />
              
              <Form.Control 
                type="password" 
                placeholder="Password"
                onChange={(event)=> setPassword(event.target.value)} />
              </Col>

              <hr />
               <br />
              <Button 
                variant="success"
                size="sm"
                style={{width: "70%"}}
                onClick={requestLogin}
              >

                { loadingLogin === false ? (
                    <>
                      Ingresar al Sistema
                      <FontAwesomeIcon icon={faUserLock}  style={{paddingLeft:"20px"}} />
                      </> 
                    ) : (
                    <>
                      Por favor espere...
                      <FontAwesomeIcon 
                        spin
                        icon={faCircleNotch } 
                        style={{marginLeft:"20px", color:"white", cursor:"pointer"}} 
                      />
                    </>
                )}

              </Button>
              <br />
              <br />

              <Col
              style={{textAlign:"left", fontSize:"10px"}}
              >
              @2025 | Quatro Soluciones
              </Col>
            </Card.Body>

          </Card>
        
        </Col>

      </Row>
      

    {/* MODAL PASSWORD CREATE*/}
    <UserCreatePassword show={showModal_CreatePassword} requestClose={setRequestCloseModal_CreatePassword} currentUserID={currentUserID} currentUserName={username}/>


    </div>
  );
  
}

export default Login;
